import { types } from '../../../constants/ActionTypes'

const initialState = {
  anchorEl: null,
  clickedMenu: '',
}

const renjuBoardMenu = (state = initialState, action) => {
  switch (action.type) {
    case types.router.LOCATION_CHANGE:
      return { ...state, anchorEl: null }
    case types.renjuBoardMenu.OPEN:
      return { ...state, anchorEl: action.anchorEl, clickedMenu: '' }
    case types.renjuBoardMenu.CLOSE:
      return { ...state, anchorEl: null }
    case types.renjuBoardMenu.CLICKED_MENU:
      return { ...state, clickedMenu: action.menu }
    default:
      return state
  }
}

export default renjuBoardMenu



// WEBPACK FOOTER //
// ./src/reducers/Common/RenjuBoardCard/RenjuBoardMenu.js